// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nn2VJKCv10AbL4Dlzpfi{flex-grow:1;margin-left:16px;display:flex;position:relative}.ozebL0TyjOUsRst3c3JV a{color:var(--content-brand-primary);text-decoration:none}.ozebL0TyjOUsRst3c3JV a:hover{color:var(--content-brand-secondary);text-decoration:underline}.XCQXADfn4DQYn4uXtnJ_{justify-content:space-between;align-items:center;gap:12px;width:100%;min-width:0;display:flex}.CZi6yMRVMEM53LGNAZzK{flex:auto;align-items:center;gap:12px;min-width:0;display:flex;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapTable": `nn2VJKCv10AbL4Dlzpfi`,
	"reason": `ozebL0TyjOUsRst3c3JV`,
	"contactColumn": `XCQXADfn4DQYn4uXtnJ_`,
	"contactColumnName": `CZi6yMRVMEM53LGNAZzK`
};
export default ___CSS_LOADER_EXPORT___;
